
// @ts-nocheck





import { i18nText } from '@/locales';


import { Component, Vue, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import { SimpleProxyForm } from "@/UI/components/Helpers/SimpleProxyForm";
import { FormLayoutMix } from "@/UI/mixins/Layouts/Form";

import { ClientsStore } from "@/store/modules/Clients";
import { PaginationMix } from "@/UI/mixins/PaginationMix";
import {
  Col,
  DatePicker,
  FormModel,
  Input,
  Row,
  Select,
  Tabs,
  AutoComplete,
  Modal,
  TimePicker,
  Tree,
  Button,
} from "ant-design-vue";
import { HandleScrollStorewithParam, HandleScrollStore, SearchinStore } from "@/UI/Decorators/decorator";
import { TreeTransfer } from "@/UI/lib/calculte";
import { ServiceStore } from "@/store/modules/Services";
import { getStudioId } from "@/UI/lib/state";
import { SourcesMix } from "@/UI/mixins/SourcesMix";
import { SourcesStore } from "@/store/modules/Sources";
import { ServicesMix } from "@/UI/mixins/Service/ServicesMix";
import moment from "moment";
import { WorkersMix } from "@/UI/mixins/Store/WorkersMix";
import { WorkersStore } from "@/store/modules/Workers";
import { AppStateStore } from "@/store/modules/appState";
import { DateMix } from "@/UI/mixins/Calendar/DateMix";
import dayjs from "dayjs";
import RecordStatus from "@/UI/pages/visitsNew/Components/RecordStatus.vue";
import { ClientCategoryStore } from "@/store/modules/ClientsCategory";
import EAutoComplete from "@/UI/components/EAutoComplete/EAutoComplete.vue";
import EDateTimePicker from "@/UI/components/EDateTimePicker/EDateTimePicker.vue";
import { RouterNameEnum } from "@/router/router.types";
import { AppFormsStore } from "@/store/modules/appForms";

import { FormRules, RecordDataForm } from "@/form/visits/New/Record";
import { VisitsStore } from "@/store/modules/Visits";
import { VisitsGeneralMix } from "@/UI/mixins/Visits/VisitsGeneralMix";
import { DateTime } from "ts-luxon";
import { showNotificationSimple } from "@/UI/lib/messages";
import { IClientsListItem } from "@/entity/clients/clients.types";
import { lxDateToSpecFormat, parseDateFormatted, addPrefix } from "@/UI/lib/parseSupport";
import { ClientsMix } from "@/UI/mixins/ClientsMix";
import {
  getVisitData,
  updateVisitData,
  newVisitS,
  parseVisitsData,
  checkFormServiceDataNew,
  parseVisitsCurrentData,
  RecordParams,
  RecordParamsData,
  getVisitId,
} from "@/UI/pages/visitsNew/Lib/support";
import { servicePrice, selectedClient } from "@/UI/pages/visitsNew/Lib/money";
import { LoyaltySubscriptionStore } from "@/store/modules/Loyalty/Subscription/LoyaltySubscription";

@Component({
  components: {
    RecordStatus,
    BaseDataForm,
    "a-modal": Modal,
    "a-button": Button,
    "a-input": Input,
    "a-select": Select,
    "a-select-option": Select.Option,
    "a-select-opt-group": Select.OptGroup,
    "a-col": Col,
    "a-row": Row,
    "a-date-picker": DatePicker,
    "a-textarea": Input.TextArea,
    "a-form-model": FormModel,
    "a-form-model-item": FormModel.Item,
    "a-tabs": Tabs,
    "a-tab-pane": Tabs.TabPane,
    "a-auto-complete": AutoComplete,
    "e-auto-complete": EAutoComplete,
    "a-time-picker": TimePicker,
    "a-tree": Tree,
    "e-datetimepicker": EDateTimePicker,
  },
  methods: { moment, dayjs, newVisitS },
})

export default class Create extends mixins(
  SimpleProxyForm,
  ClientsMix,
  FormLayoutMix,
  PaginationMix,
  ServicesMix,
  SourcesMix,
  WorkersMix,
  VisitsGeneralMix,
  DateMix,
  EDateTimePicker,
) {
  servicesModal: boolean = false;
  sData = {};
  servicesTree = new TreeTransfer();
  dtreeServicesData: any = [];
  vForm: RecordDataForm = new RecordDataForm();
  initialForm: RecordDataForm = new RecordDataForm();
  rules = FormRules;
  clientChanged: boolean = false;
  disableControls: boolean = false;
  isFinishedVisit: boolean = false;

  async serviceSearch(value: string): Promise<void> {
    await this.hSearchWp("services", value, false, "name", {
      name: value,
      salon_id: getStudioId(this),
    });
  }

  async controlClientSelect(value: boolean): Promise<void> {
    this.disableControls = value;
  }

  get currentClient(): IClientsListItem | null {
    return selectedClient(this.client, this.vForm.client_id);
  }

  get staffCategoryId(): number {
    const worker = this.workers?.data.find((item) => Number(item.id) === Number(this.vForm.cosmetologists_id));
    return Number(worker?.cosmetolog_category_id);
  }

  @Watch("$route", { immediate: true, deep: true })
  onUrlChange(): void {
    if (AppFormsStore.status) {
      AppFormsStore.setNotReady();
      if (AppFormsStore.boxData && AppFormsStore.boxData[0]) {
        AppFormsStore.boxData[0].map(async (service: number) => {
          await ServiceStore.fetchData({ filter: { id: service } });
          if (this.vForm.service_data && this.services) {
            const id = this.services["id"];
            const result = this.service?.data.filter((value) => value.id === id).length;
            if (result === 0) {
              await ServiceStore.add(this.services);
            }
            this.vForm.service_data.push({
              service_id: this.services["id"],
              price: servicePrice(this.services, this.staffCategoryId),
              quantity: 1,
              service: this.services,
              service_duration: this.services["service_duration"],
            });
            await this.vForm.parseDuration(false);
          }
        });
      }
    }
  }

  async AddService(): Promise<void> {
    if (this.vForm.service_data) {
      this.vForm.service_data.push({
        service_id: null,
        quantity: 1,
        price: 0,
        service: null,
        service_duration: "",
      });
    }
    await this.vForm.parseDuration(false);
  }

  async deleteService(service: number): Promise<void> {
    if (this.vForm.service_data) {
      this.vForm.service_data.splice(
        this.vForm.service_data.findIndex((serviceIndex) => serviceIndex["service_id"] === service),
        1,
      );

      // await this.vForm.parseDuration(false, this.vForm.visit_date + ","+(this.$refs["startTimePicker"] as TimePicker).value.format("HH:mm"));
      await this.vForm.parseDuration(false, this.vForm.visit_date + "," + (this.$refs["startTimePicker"] as any).value.format("HH:mm"));
    }
  }

  async showServices(): Promise<void> {
    AppFormsStore.clearData();
    AppFormsStore.setNotReady();
    await Vue.router.push({
      name: RouterNameEnum.VisitsNewService,
    });
  }

  modalOk(): void {
  }

  async calculateQuantity(): Promise<void> {
    await this.vForm.parseDuration(false);
  }

  async StatusChange(): Promise<void> {
    // await this.saveVisit(false);
  }

  async saveVisit(noRoute: boolean, route?: any, route_name?: any): Promise<void> {
    if (Number(this.vForm.status_id) === 5) return;
    this.initialForm = { ...this.vForm };
    (this.$refs.RecordForm as any).validate(async (valid) => {
      if (!valid) {
        AppStateStore.setSubmit(false);
        return
      }

      if (newVisitS()) {
        this.vForm.service_data = this.vForm.service_data?.filter((t: any) => t.service_id !== null) as any

        const startTp = (this.$refs["startTimePicker"] as any).value.format("HH:mm"),
          endTp = (this.$refs["endTimePicker"] as any).value.format("HH:mm"),
          durationTp = (this.$refs["durationTimePicker"] as any).value.format("HH:mm");

        this.vForm.setVisitDt(startTp, endTp);
        this.vForm.visit_duration = durationTp;

        if (
          !this.vForm.checkDuration(this.vForm, this.$store.state["visits"]["workersInVisits"], 0, {
            start: this.vForm.exportFormatedDates().startDt as any,
            end: this.vForm.exportFormatedDates().endDt as any,
          }).result
        ) {
          AppStateStore.setSubmit(false);

          await updateVisitData(
            true,
            this.vForm,
            RecordParamsData(),
            noRoute,
            VisitsStore,
            AppStateStore,
            newVisitS(),
            getStudioId(this),
            route,
            route_name
          );

          await this.getVisitsG();
        } else {
          AppStateStore.setSubmit(false);
          showNotificationSimple(i18nText("Время визита уже занято"), "", 10);
        }
      } else {
        if (!this.vForm.checkDuration(this.vForm, this.$store.state["visits"]["workersInVisits"], getVisitId(), {
          start: this.vForm.exportFormatedDates().startDt as any,
          end: this.vForm.exportFormatedDates().endDt as any,
        }).result) {
          AppStateStore.setSubmit(false);

          await updateVisitData(
            true,
            this.vForm,
            RecordParamsData(),
            noRoute,
            VisitsStore,
            AppStateStore,
            newVisitS(),
            getStudioId(this),
            route,
            route_name
          );

          await this.getVisitsG();
        } else {
          AppStateStore.setSubmit(false);
          showNotificationSimple(i18nText("Время визита уже занято"), "", 10);
        }
      }
    })
  }

  @Watch("$store.state.appState.sendSubmit", { immediate: false })
  async ButtonSubmit(): Promise<void> {
    if (AppStateStore.sendSubmit) {
      AppStateStore.setUpdate(false);
      await this.saveVisit(false);
      if (AppStateStore.success) {
        this.$router.currentRoute.params["mode"] = "created";
        document.querySelector('.visit-menu .visit-menu__details +  *').click();

        /*if (this.visit && this.visit.order && this.visit.order.paid !== this.visit && this.visit.order && this.visit.order.sum) {
          showNotificationSimple("Визит оплачен не полностью", "", 10);
        }*/
      }
    }
  }

  @Watch("$store.state.appState.sendDelete", { immediate: false })
  async ButtonDelete(): Promise<void> {
    if (AppStateStore.sendDelete) {
      AppStateStore.setDelete(false);
      await this.deleteVisit(this.vForm);
    }
  }

  @Watch("$store.state.appState.sendCancel", { immediate: false })
  async ButtonCancel(): Promise<void> {
    if (AppStateStore.sendCancel) {
      AppStateStore.setCancel(false);
      await this.pushToCalendar(this.vForm, RecordParamsData());
    }
    /*if (this.visit && this.visit.order && this.visit.order.paid !== this.visit && this.visit.order && this.visit.order.sum) {
      showNotificationSimple("Визит оплачен не полностью", "", 10);
    }*/
  }

  //TODO:: Добавить контроль времени
  /*handleTimeDate(): void {
    //this.vForm.visit_date = time.format("YYYY-MM-DD");
    //this.vForm.visit_date = new Date(value["_d"]).toLocaleDateString("ru-RU");
    //this.vForm.parseDuration(true, this.vForm.visit_date + "," + this.vForm.visit_date_time_start);
  }*/

  changeStartTime(time: any): void {

    const durationTp = (this.$refs["durationTimePicker"] as any).value.format("HH:mm");
    //endTp = (this.$refs["endTimePicker"] as any).value.format("HH:mm");

    let endTime = null,
      startTime = this.vForm.visit_date + "," + time.format("HH:mm");

    const check = this.vForm.checkTimeInterval(0, time.format("HH:mm"), durationTp);

    if (!check.changed) {
      let dt = DateTime.now().toLocal();
      dt = dt.set({
        hour: Number(time.format("HH:mm").split(":")[0]),
        minute: Number(time.format("HH:mm").split(":")[1]),
      });
      dt = dt.plus({ hour: Number(durationTp.split(":")[0]), minute: Number(durationTp.split(":")[1]) });
      endTime = this.vForm.visit_date + "," + dt.toLocaleString(DateTime.TIME_24_SIMPLE as any);
    } else {
      if (check.newStart && check.newEnd) {
        startTime = this.vForm.visit_date + "," + check.newStart;
        endTime = this.vForm.visit_date + "," + check.newEnd;
      }

      if (check.newStart && !check.newEnd) {
        startTime = this.vForm.visit_date + "," + check.newStart;
      }
      if (check.newEnd && !check.newStart) {
        startTime = this.vForm.visit_date + "," + time.format("HH:mm");
        endTime = this.vForm.visit_date + "," + check.newEnd;
      }
    }

    this.vForm.parseDuration(false, startTime, endTime);

    const result = this.vForm.checkDuration(
      this.vForm,
      this.$store.state["visits"]["workersInVisits"],
      getVisitId(),
      {
        start: this.vForm.exportFormatedDates().startDt as any,
        end: this.vForm.exportFormatedDates().endDt as any,
      },
    );

    if (result.result) {
      showNotificationSimple(i18nText("предупреждение"), i18nText("время визита занято"), 10);
    }
  }

  changeDuration(time: any): void {
    const startTime = this.vForm.visit_date + "," + this.vForm.visit_date_time_start;
    const pDate = parseDateFormatted(startTime);
    let dt = DateTime.now();
    let allowChange = true;

    if (pDate) {
      dt = dt.set({
        hours: pDate.hours,
        minutes: pDate.minutes,
        year: pDate.year,
        month: pDate.month,
        day: pDate.day,
      });
      if (Number(pDate.hours) + Number(time.hour()) > 23) allowChange = false;
      dt = dt.plus({ hours: Number(time.hour()), minute: Number(time.minutes()) });
    }

    if (allowChange) {
      this.vForm.visit_duration = time.format("HH:mm");
      let endTime = lxDateToSpecFormat(dt);
      endTime = endTime.replaceAll(" ", ",");
      this.vForm.parseDuration(true, startTime, endTime);
    } else {
      showNotificationSimple(i18nText("! превышение интервала визита"), "", 10);
    }
  }

  changeEndTime(time: any): void {
    // const startTp = (this.$refs["startTimePicker"] as TimePicker).value.format("HH:mm")
    const startTp = (this.$refs["startTimePicker"] as any).value.format("HH:mm")

    let endTime = null,
      startTime = this.vForm.visit_date + "," + startTp;

    const check = this.vForm.checkTimeInterval(
      1,
      time.format("HH:mm"),
      // (this.$refs["durationTimePicker"] as TimePicker).value.format("HH:mm")
      (this.$refs["durationTimePicker"] as any).value.format("HH:mm")
    );
    if (!check.changed) {
      endTime = this.vForm.visit_date + "," + time.format("HH:mm");
    } else {
      if (check.newEnd && !check.newStart) {
        endTime = this.vForm.visit_date + "," + check.newEnd;
      }
      if (check.newEnd && check.newStart) {
        startTime = this.vForm.visit_date + "," + check.newStart;
        endTime = this.vForm.visit_date + "," + check.newEnd;
      }
    }

    this.vForm.parseDuration(true, startTime, endTime);

    const result = this.vForm.checkDuration(
      this.vForm,
      this.$store.state["visits"]["workersInVisits"],
      getVisitId(),
      {
        start: this.vForm.exportFormatedDates().startDt as any,
        end: this.vForm.exportFormatedDates().endDt as any,
      },
    );
    if (result.result) {
      showNotificationSimple(i18nText("предупреждение"), i18nText("время визита занято"), 10);
    }
  }

  async setPhone(): Promise<void> {
    this.clientChanged = true;
  }
  async selectPhone(): Promise<void> {
    this.clientChanged = true;
  }

  async selectClient(value: any, option: any): Promise<void> {
    const key = Number((option["key"] as string).replace("cl-", ""));

    await LoyaltySubscriptionStore.fetchAll({ filter: { client_id: key } })
    this.vForm.client_id = key;
    this.vForm.new_client = false;

    await ClientsStore.fetchData({ filter: { id: key } });

    if (this.client) {
      this.clientChanged = true;

      this.vForm.client_name = this.client["name"];
      this.vForm.client_phone = this.client["phone"];

      if (this.client["source"] && !isNaN(this.client["source"][0])) {
        this.vForm.client_source = this.client["source"];
      } else this.vForm.client_source = [];

      await ClientsStore.clientDebtData();
    }
  }

  modalCancel(): void {
    this.servicesModal = false;
  }

  async changeSelect(): Promise<void> {
    this.vForm.client_id = 0;
  }

  async serviceChange(index: any, value: any): Promise<void> {
    await ServiceStore.fetchData({ filter: { id: index } });
    const ServiceData = this.services;

    if (this.vForm.service_data && ServiceData) {
      this.vForm.service_data[value]["price"] = servicePrice(ServiceData, this.staffCategoryId);
      this.vForm.service_data[value]["service_id"] = ServiceData["id"];
      this.vForm.service_data[value]["service_duration"] = ServiceData["service_duration"];
      this.vForm.service_data[value]["service"] = ServiceData;
    }

    await this.vForm.parseDuration(false,
      this.vForm.visit_date + "," + (this.$refs["startTimePicker"] as any).value.format("HH:mm")
    );
  }

  @SearchinStore
  hSearch(source: string, value: string, useStudio: boolean, name?: string): void {
  }

  @SearchinStore
  hSearchWp(source: string, value: string, useStudio: boolean, name?: string, filter?: any): void {
  }

  @HandleScrollStorewithParam
  hScroll(event: any, source: string, items: string): void {
  }

  handleScrollServices(event: any, source: string, items: string): void {
    this.hScroll(event, "services", "service");
  }

  onSelect(selectedKeys: any, info: any) {
    console.log("selected", selectedKeys, info);
  }

  onServiceCheck(checkedKeys: any, info: any): void {
    console.log("onCheck", checkedKeys, info);
    this.servicesTree.setValue(checkedKeys);
  }

  handleSearch(source: string, value: string, useStudio: boolean): void {
    this.hSearch(source, value, useStudio);
  }

  handleSearchWithName(source: string, value: string, useStudio: boolean, name: string): void {
    this.hSearch(source, value, useStudio, name);
  }

  async searchClient(value: any): Promise<void> {
    await ClientsStore.clearItems();


    this.handleSearch("clients", value, true);
  }

  searchPhone(value: any): void {
    this.handleSearchWithName("clients", value, true, "phone");
  }

  async selectWorker(): Promise<void> {
    await VisitsStore.VisitsByWorker(Number(this.vForm.cosmetologists_id));
    this.selectWorkerPosition();
    this.vForm.service_data?.forEach((line) => {
      if (line.service) line.price = servicePrice(line.service, this.staffCategoryId);
    });
    await this.vForm.parseDuration(false, this.vForm.visit_date + "," + this.vForm.visit_date_time_start);
  }

  selectWorkerPosition(): void {
    let currentStaff = this.workers.data.filter((item: Record<any, any>) => {
      return item.id == this.vForm.cosmetologists_id;
    });
    if (currentStaff.length) {
      this.vForm.staff_position = currentStaff[0].position_id == 1 ? 'admin' : 'staff';
    }
  }

  async clientData(): Promise<void> {
    if (!newVisitS()) {
      await ClientsStore.fetchData({
        limit: 10,
        filter: { id: this.vForm["client_id"] },
      });
    }
  }

  async visitData(): Promise<void> {
    if (!newVisitS()) {
      const visitId = RecordParamsData().id;

      if (visitId !== 0) {
        await getVisitData(Number(RecordParamsData().id), VisitsStore);
        await this.vForm.parseVisitData(this.visit);
        await this.vForm.parseDuration(true);
      } else {
        await getVisitData(Number(RecordParams().id), VisitsStore);
        await this.vForm.parseVisitData(this.visit);
        await this.vForm.parseDuration(true);
      }

      if (this.visit && (Number(this.visit.status_id) === 5 || (this.visit.order && parseFloat(this.visit.order.paid) == parseFloat(this.visit.order.sum)))) {
        this.isFinishedVisit = true;
      }

    } else {
      await this.vForm.prepareVisit(RecordParamsData(), getStudioId(this));
      const params = JSON.parse(this.$route.params["params"]);
      await parseVisitsCurrentData(
        DateTime.fromSQL(RecordParamsData()["date"] as string).toLocal(),
        getStudioId(this),
        VisitsStore,
      );
      await VisitsStore.VisitsByWorker(params["category"]["id"]);
      //TODO::Доработать
      await this.vForm.parseDuration(false);
    }
  }

  async getVisitsG(): Promise<void> {
    let vDate = "";
    if (newVisitS()) {
      vDate =
        addPrefix(String(RecordParamsData()["day"])) +
        "." +
        addPrefix(String(RecordParamsData()["month"])) +
        "." +
        addPrefix(String(RecordParamsData()["year"]));
    } else {
      if (RecordParamsData().visitData !== undefined) {
        vDate =
          addPrefix(
            String(parseDateFormatted(RecordParamsData().visitData["visit_dt"].replace(" ", ",")).day),
          ) +
          "." +
          addPrefix(
            String(
              parseDateFormatted(RecordParamsData().visitData["visit_dt"].replace(" ", ",")).month,
            ),
          ) +
          "." +
          addPrefix(
            String(parseDateFormatted(RecordParamsData().visitData["visit_dt"].replace(" ", ",")).year),
          );
      } else {
        vDate =
          addPrefix(String(parseDateFormatted(RecordParamsData()["visit_dt"].replace(" ", ",")).day)) +
          "." +
          addPrefix(String(parseDateFormatted(RecordParamsData()["visit_dt"].replace(" ", ",")).month)) +
          "." +
          addPrefix(String(parseDateFormatted(RecordParamsData()["visit_dt"].replace(" ", ",")).year));
      }
    }

    await parseVisitsData(vDate, vDate, VisitsStore, getStudioId(this));
    await VisitsStore.VisitsByWorker(Number(this.vForm.cosmetologists_id));
  }

  async beforeDestroy(): Promise<void> {
    if (
      this.vForm.client_name &&
      this.vForm.client_phone &&
      this.vForm.client_source &&
      this.vForm.cosmetologists_id &&
      Vue.router.currentRoute.params.mode === 'create' &&
      Vue.router.currentRoute.name === "VisitsNewStatus" ||
      Vue.router.currentRoute.name === "VisitsNewPay" ||
      Vue.router.currentRoute.name === "VisitsNewHistory" ||
      Vue.router.currentRoute.name === "VisitsNewProducts"
    ) {
      await this.saveVisit(false, 'yes', Vue.router.currentRoute.name)
    }
  }

  beforeRouteLeave(to: Record<string, any>, from: Record<string, any>, next: (arg0: boolean | undefined) => void) {
    if (Number(this.vForm.status_id) === 5) { next(undefined); return; }
    // ----- check for unsaved changes inside form (Starting line.) -----
    let initialFormChanged = false;
    for (const key in this.initialForm) {
      if (Object.hasOwnProperty.call(this.initialForm, key)) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        let element = this.initialForm[key];
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        let newEl = this.vForm[key];
        if (element == null) {
          element = "";
        }
        if (newEl == null) {
          newEl = "";
        }

        if (element != newEl && typeof element === 'string' && key !== 'visit_dt' && key !== 'visit_dt_end') {
          initialFormChanged = true;
        }
      }
    }
    if (initialFormChanged) {
      Modal.confirm({
        onOk: (): void => {
          try {
            if (
              this.vForm.client_name &&
              this.vForm.client_phone &&
              this.vForm.client_source &&
              this.vForm.cosmetologists_id &&
              Vue.router.currentRoute.params.mode === 'create' &&
              Vue.router.currentRoute.name === "VisitsNewStatus" ||
              Vue.router.currentRoute.name === "VisitsNewPay" ||
              Vue.router.currentRoute.name === "VisitsNewHistory" ||
              Vue.router.currentRoute.name === "VisitsNewProducts"
            ) {
              this.saveVisit(false, 'yes', Vue.router.currentRoute.name)
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              next();
              Modal.destroyAll();
              this.$destroy();
            } else {
              next(false);
              // ----- return selected item back for visit-menu (Starting line.) -----
              let element: HTMLElement = document.querySelector('.visit-menu .visit-menu__details') as HTMLElement;
              element.click();
              // ----- return selected item back for visit-menu (Ending line.) -----
            }
          } catch (e) {
            console.error(e.message);
          }
        },
        onCancel: (): void => {
          Modal.destroyAll();
          this.$destroy();
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          next();
        },

        autoFocusButton: "true",
        content: i18nText("Информация о записи была изменена. Вы точно хотите утратить заполненные данные?"),
        okText: i18nText("Нет"),
        cancelText: i18nText("Да"),
      });
    } else {
      Modal.destroyAll();
      this.$destroy();
      next(undefined);
    }
    // ----- check for unsaved changes inside form (Ending line.) -----
  }

  async getData(): Promise<void> {
    try {
      await SourcesStore.fetchAll();
      await ServiceStore.fetchAll({ filter: { salon_id: getStudioId(this) } });
      await ClientCategoryStore.fetchAll({});
      await WorkersStore.fetchAll({ filter: { salon_id: getStudioId(this) } });

      await ClientsStore.fetchAll({
        limit: 10,
        filter: { salon_id: getStudioId(this) },
      });
      await this.visitData();
      await this.clientData();

      await this.getVisitsG();

      await checkFormServiceDataNew(this.vForm, this.$store);
      this.selectWorkerPosition();
    } catch (e) {
      console.log("Error create Visit Form: ");
      console.error(e);
    }
  }

  async mounted(): Promise<void> {
    try {
      this.formReady = false;
      await this.getData();
    } catch (e) {
      console.log("Mount Visit form Error :");
      console.error(e);
    } finally {
      await ClientsStore.clientDebtData();
      this.formReady = true;
      this.initialForm = { ...this.vForm };


      // ----- visitIsFullyPaid (Starting line.) -----
      if (this.visit && this.visit.order.paid == this.visit.order.sum) {
        this.visitIsFullyPaid = true;
      } else {
        this.visitIsFullyPaid = false;
      }
      // ----- visitIsFullyPaid (Ending line.) -----


      // ----- если мы сохраняем в "Статус визита" добавленную услугу то на вкладке "Детали записи" у нее длительность 0, также как и на календаре записей,  fix (Starting line.) -----
      await this.vForm.parseDuration(false);
      // ----- если мы сохраняем в "Статус визита" добавленную услугу то на вкладке "Детали записи" у нее длительность 0, также как и на календаре записей,  fix (Ending line.) -----

    }
  }

  async created(): Promise<void> {

    try {
      this.formReady = false;
    } catch (e) {
      console.log(i18nText("Ошибка создания формы визита -:"));
      console.error(e);
    }
  }

  get membeships_balance(): any {
    return LoyaltySubscriptionStore.loyaltySubscriptions?.data
  }
}
